import { render, staticRenderFns } from "./EditLeads.vue?vue&type=template&id=01964508&scoped=true"
import script from "./EditLeads.vue?vue&type=script&lang=js"
export * from "./EditLeads.vue?vue&type=script&lang=js"
import style0 from "./EditLeads.vue?vue&type=style&index=0&id=01964508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01964508",
  null
  
)

export default component.exports